import { render, staticRenderFns } from "./StaffHolidayWorkList.vue?vue&type=template&id=3215d543"
import script from "./StaffHolidayWorkList.vue?vue&type=script&lang=js"
export * from "./StaffHolidayWorkList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports